import { render } from "./BasePageSpinnerNew.vue?vue&type=template&id=fc7edf54&scoped=true"
import script from "./BasePageSpinnerNew.vue?vue&type=script&lang=js"
export * from "./BasePageSpinnerNew.vue?vue&type=script&lang=js"

import "./BasePageSpinnerNew.vue?vue&type=style&index=0&id=fc7edf54&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc7edf54"]])

export default __exports__